import {Deserializable} from './deserializable';


export class DevicePilomatOwerRel implements Deserializable {

  serial: string;
  userUid: string;

  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }
}
